import api from "@/lib/api";
import type { LoginResponseData, LoginCredentials } from "../types";
import type { ApiUser } from "@/features/users/types";

const AUTH_ENDPOINTS = {
  LOGIN: "/token/",
  REFRESH: "/token/refresh/",
  USER_ME: "/users/me/",
  PASSWORD_RESET_REQUEST: "/users/password-reset/request/",
  PASSWORD_RESET_VERIFY: "/users/password-reset/verify-code/",
  PASSWORD_RESET_COMPLETE: "/users/password-reset/complete/",
};

export class AuthHttpRepository {
  async login(credentials: LoginCredentials): Promise<LoginResponseData> {
    const result = await api.post(AUTH_ENDPOINTS.LOGIN, credentials);
    return result.data;
  }
  async refresh(refreshToken: string): Promise<{ access: string }> {
    const result = await api.post(AUTH_ENDPOINTS.REFRESH, {
      refresh: refreshToken,
    });
    return result.data;
  }
  async loadUser(): Promise<ApiUser> {
    const result = await api.get(AUTH_ENDPOINTS.USER_ME);
    return result.data;
  }
  async requestPasswordReset(email: string): Promise<{ message: string }> {
    const result = await api.post(AUTH_ENDPOINTS.PASSWORD_RESET_REQUEST, {
      email,
    });
    return result.data;
  }
  async verifyResetCode(
    email: string,
    code: string,
  ): Promise<{ valid: boolean }> {
    const result = await api.post(AUTH_ENDPOINTS.PASSWORD_RESET_VERIFY, {
      email,
      code,
    });
    return result.data;
  }
  async completePasswordReset(
    email: string,
    code: string,
    password: string,
  ): Promise<{ message: string }> {
    const result = await api.post(AUTH_ENDPOINTS.PASSWORD_RESET_COMPLETE, {
      email,
      code,
      password,
    });
    return result.data;
  }
}
